var desktopLogoImage = "/static/0b87360240be5c87.svg";

export { desktopLogoImage as default };
//# sourceMappingURL=logo.svg.js.map
